import React, { ChangeEvent, FC } from 'react';
import './number-input.css';

interface Props {
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  value: number;
}

export const NumberInput: FC<Props> = ({
  onChange,
  min = 1,
  max,
  step = 1,
  value = 1,
}) => {

  const checkValueValidation = (e: ChangeEvent<HTMLInputElement>) => {
    const currValue = parseInt(e.target.value);
    const val = (max && currValue > max) ? max : (min && currValue < min) ? min : (currValue % step) > 0 ? value : currValue;

    onChange(val);
  };

  return (
    <label className="number-wrapper">
      <input
        type="number"
        className="number-input"
        onChange={checkValueValidation}
        min={min}
        max={max}
        step={step}
        value={value}
      />
    </label>
  );
};
